import React from "react";

import { UniverseCard } from "@companion-core/shared/app/Components/Cards/UniverseCard";
import { UniversesContentProps } from "./content.model";
import { Button } from "@companion-core/shared/app/Components/Button";
import { useMountEffect } from "@companion-core/shared/app/Hooks/useMountEffect";
import {
  trackUniversesPage,
  trackUniversesClick,
  trackSkipUniversesClick,
} from "@companion-core/shared/app/tracking/blocks";

import "@companion-core/web/src/Assets/Styles/scss/universesLayout.scss";

export const Universes = ({ t, universes, onPressUniverse, skipAction }: UniversesContentProps) => {
  useMountEffect(() => {
    trackUniversesPage();
  });

  return (
    <div className="universes-layout">
      <div className="universes-layout__header">
        <h1 className="universes-layout__title title-5">{t("blocks.universes.title")}</h1>
        <p className="universes-layout__description body-text-6">
          {t("blocks.universes.description")}
        </p>
      </div>
      <div className="universes-layout__content">
        <div className="universes-layout__grid">
          {universes?.map((universe) => (
            <UniverseCard
              key={universe.id}
              universe={universe}
              onClick={() => {
                trackUniversesClick({ universeSlug: universe.slug });
                onPressUniverse(universe);
              }}
            />
          ))}
        </div>
      </div>
      <div className="universes-layout__footer">
        <Button
          label={t("blocks.universes.skip")}
          testID="universes-layout__button--see-all"
          type="link"
          onClick={() => {
            trackSkipUniversesClick();
            skipAction();
          }}
        />
      </div>
    </div>
  );
};
